import { render, staticRenderFns } from "./ExtraIndex.vue?vue&type=template&id=29d91f0c"
import script from "./ExtraIndex.vue?vue&type=script&lang=js"
export * from "./ExtraIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports